// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__FoLhL","messages":"Chat_messages__2_xNv","dateDivider":"Chat_dateDivider__3RDkY"};